import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  platformType: "",
};

export const platformTypeSlice = createSlice({
  name: "platformTypeChecker",
  initialState,
  reducers: {
    setPlatformTypeReducer: {
      reducer: (state, action) => {
        state.platformType = action.payload.platformType;
      },
    },
  },
});

export const { setPlatformTypeReducer } = platformTypeSlice.actions;

export default platformTypeSlice.reducer;
